import Loading from '../components/Loading';
import React from 'react';
import socialToken from '../actions/socialToken';

export const context = 'idpToken';
export class IdpTokenRoute extends React.PureComponent {
    state = {
        error: '',
    };

    async componentDidMount() {
        try {
            await socialToken();
        } catch (error) {
            this.setState({
                error: error.message,
            });
        }
    }

    render() {
        const { error } = this.state;

        if (error) {
            throw error;
        }
        return <Loading />;
    }
}

export default IdpTokenRoute;
